import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import MDBox from 'components/MDBox';
import { useState } from 'react';

const StudentTagSwitch = (props) => {
  const { setTags, tagKey, tagValue, selectedTags, setChangeTag } = props;
  const isTagSelected = selectedTags.includes(tagKey);
  const [tagToggle, setTagToggle] = useState(isTagSelected || false);

  const handleTagChange = (event) => {
    setChangeTag(true);
    const isChecked = event.target.checked;
    setTagToggle(isChecked);
    if (isChecked) {
      setTags((prev) => [...prev, tagKey]);
    } else {
      setTags((prev) => prev.filter((tag) => tag !== tagKey));
    }
  };

  return (
    <MDBox>
      <FormControlLabel
        control={
          <Switch defaultChecked={tagToggle} onChange={handleTagChange} />
        }
        label={tagValue}
      />
    </MDBox>
  );
};

export default StudentTagSwitch;
